/**
 *
 */
export enum PropertyTypeID {
  ResidentialLand = 0,
  HouseOrVilla = 1,
  FarmLand = 2,
  CommercialLand = 4,
}
